<template>
    <div v-loading="loading" class="card-deal">
        <div class="card-deal-header caption-block">
            <div class="title">
                Карточка задачи
            </div>
            <div class="actions">
                <span class="btn btn-default orange action-edit" @click="save">
                    {{ saveBtnText }}
                </span>
                <div class="btn btn-default grey action-close" @click="close">
                    Отменить
                </div>
            </div>
        </div>
        <el-row class="tasks-wrapper tasks-edit mobile-wrapper">
            <el-col justify="start" class="card task-main-info">
                <el-form :model="task" label-position="top">
                    <el-row class="task-item-row row">
                        <div class="label">
                            Заголовок
                        </div>
                        <div :class="{ 'error-input': errors.title }">
                            <el-input v-model="task.title" size="mini" autocomplete="off" />
                            <div class="error" v-if="errors.title">
                                {{ errors.title[0] }}
                            </div>
                        </div>
                    </el-row>
                    <el-row v-if="!isNew" class="task-item-row row">
                        <el-col :span="24" :class="['task-item-status fab', { 'error-input': errors.status_id }]">
                            <div class="label">
                                Статус
                            </div>
                            <el-select v-model="task.status_id" placeholder="" size="mini">
                                <el-option
                                    v-for="taskStatus in taskStatuses"
                                    :key="taskStatus.id"
                                    :label="taskStatus.name"
                                    :value="taskStatus.id"
                                />
                            </el-select>
                            <div class="error" v-if="errors.status_id">
                                {{ errors.status_id[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="task-item-row row">
                        <el-col :span="24" :class="['task-item-priority fab', { 'error-input': errors.priority }]">
                            <div class="label">
                                Приоритет
                            </div>
                            <el-select v-model="task.priority" placeholder="" size="mini">
                                <el-option
                                    v-for="taskPriority in taskPriorityList"
                                    :key="taskPriority.id"
                                    :label="taskPriority.name"
                                    :value="taskPriority.id"
                                />
                            </el-select>
                            <div class="error" v-if="errors.priority">
                                {{ errors.priority[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="!isNew" class="task-item-row row">
                        <div class="label">
                            Дата создания
                        </div>
                        <div class="value">
                            {{ task.created_at }}
                        </div>
                    </el-row>
                    <el-row class="task-item-row row">
                        <el-col :span="24" :class="['task-item-planned fab', { 'error-input': errors.planned }]">
                            <div class="label">
                                Срок
                            </div>
                            <div class="input-field">
                                <template>
                                    <div class="block date-picker">
                                        <el-date-picker
                                            v-model="task.planned"
                                            type="date"
                                            placeholder="дата"
                                            clearable
                                            format="dd.MM.yyyy"
                                            value-format="dd.MM.yyyy"
                                            size="mini"
                                            class="w100"
                                            :picker-options="pickerOptions"
                                        />
                                    </div>
                                </template>
                                <div class="error" v-if="errors.planned">
                                    {{ errors.planned[0] }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="!isNew" class="task-item-row row">
                        <div class="label">
                            Сделка или лид
                        </div>
                        <template v-if="issetRelatedEntity">
                            <div class="link value" @click="goRelatedEntity()">
                                {{ task.related_entity_id }}
                            </div>
                        </template>
                    </el-row>
                    <el-row v-if="!isNew" class="task-item-row row">
                        <div class="label">
                            Постановщик
                        </div>
                        <div>
                            {{ createdUserName }}
                        </div>
                    </el-row>
                    <el-row class="task-item-row row">
                        <el-col :span="24" :class="['fab', { 'error-input': errors.assigned_user_id }]">
                            <div class="label">
                                Исполнитель
                            </div>
                            <div class="input-field">
                                <el-select
                                    v-model="task.assigned_user_id"
                                    autocomplete
                                    filterable
                                    clearable
                                    size="mini"
                                    placeholder="Введите имя исполнителя"
                                >
                                    <el-option
                                        v-for="employer in employerOptions"
                                        :key="employer.id"
                                        :label="employer.name"
                                        :value="employer.id"
                                    />
                                </el-select>
                                <div class="error" v-if="errors.assigned_user_id">
                                    {{ errors.assigned_user_id[0] }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="!isNew" class="task-item-row row">
                        <div class="label">
                            Дата завершения
                        </div>
                        <div>
                            {{ task.finished }}
                        </div>
                    </el-row>
                    <el-row class="task-item-row row task-item-files">
                        <div class="top">
                            <div class="label">
                                Файлы
                            </div>
                            <el-upload
                                class="task-card-upload"
                                action=""
                                :auto-upload="false"
                                :on-change="handleChange"
                                :on-exceed="handleExceed"
                                :limit="10"
                                :file-list="uploadFileList"
                                :show-file-list="false"
                                multiple
                                accept="*"
                            >
                                <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer" />
                            </el-upload>
                        </div>
                        <div class="task-card-files">
                            <el-tag
                                v-for="file in uploadFileList"
                                :key="file.name"
                                closable
                                type=""
                                @close="handleClose(file)"
                                class="pointer ellipsis"
                                size="mini"
                                :disable-transitions="true"
                            >
                                {{ file.name }}
                            </el-tag>
                            <div class="field-error" v-if="errors.place_photo" v-text="errors.place_photo[0]"></div>
                        </div>
                    </el-row>
                </el-form>
            </el-col>
            <el-col :span="24" class="card task-comment task-item-row row" :class="{ 'error-input': errors.new_comment }">
                <div class="label">
                    Новый комментарий
                </div>
                <el-input
                    size="mini"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder=""
                    v-model="task.new_comment"
                />
                <div class="error" v-if="errors.new_comment">
                    {{ errors.comment[0] }}
                </div>
                <div class="label mt10">
                    Комментарии
                </div>
                <div class="task-comments" v-if="task.commentaries">
                    <div
                        v-for="commentDate in Object.keys(task.commentaries)"
                        :key="commentDate"
                        class="day"
                    >
                        <div class="title-date">
                            {{ getCommentDate(commentDate) }}
                        </div>
                        <div
                            v-for="comment in task.commentaries[commentDate]"
                            :key="comment.id"
                        >
                            <div class="comment">
                                <span class="name">
                                    {{ comment.employer ? comment.employer.full_name : 'неизвестен' }}
                                </span>
                                <span class="time">
                                    {{ comment.created_time }}
                                </span>
                            </div>
                            <div class="text" v-html="prepareText(comment.text)">
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import TasksCardEdit from './CardEdit';

library.add(faCheck, faPaperclip);

export default {
    name: 'TasksCardEditMobile',
    extends: TasksCardEdit
};
</script>
